<template>
    <div>
        <section class="section p-0 bg d-flex align-items-center justify-content-center">
            <div class="container text-center"><h1 class="text-white">Отзывы</h1><Breadcrumbs title="Отзывы"/></div>
        </section>
        <section class="section">
            <div class="container">
                <card class="border-0 mb-3" shadow body-classes="py-4" v-for="item in reviews" :key="item.ID">
                    <h4>{{item.NAME}}</h4>
                    <div class="row">
                        <div class="col-lg-2">
                            <img :src="$root.baseURL + item.PREVIEW_PICTURE"
                                 class="raised img-left img-fluid shadow shadow-lg--hover float-left w-100 mt-2">
                        </div>
                        <p v-html="item.DETAIL_TEXT" class="col-lg-10"></p>
                    </div>
                 </card>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                reviews: null
            };
        },
        mounted() {
            this.$axios
                .get('/rest/reviews/')
                .then(response => {
                    this.reviews = response.data
                });
            this.loadInfo();
        },
        methods: {
            async loadInfo() {
                let params_2 = new Map();
                params_2.set('entity', 'pages');
                params_2.set('code', 'reviews');

                let seo = await this.$root.loadContent(params_2)
                this.$root.title = seo[0]['SEO']['ELEMENT_META_TITLE'];
                this.$root.description = seo[0]['SEO']['ELEMENT_META_DESCRIPTION'];
            }
        }
    };
</script>
<style>
</style>